import Home from './home';
import Game from './game';
import NotFound from './notFound';
import Wheel from './wheel';
import VIP from './vip';
import VIP20 from './vip20';
import TestYourLuck from './testyourluck';
import Invite from './invite';
import FreeCash from './freecash';
import Payments from './payments';
import Tournament from './tournament';
import Tasks from './tasks';
import Lootbox from './lootbox';

export default {
    Home,
    Game,
    NotFound,
    Wheel,
    VIP,
    VIP20,
    TestYourLuck,
    Invite,
    FreeCash,
    Payments,
    Tournament,
    Tasks,
    Lootbox
}